import { dataLineChartSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLineChartSolid = /*#__PURE__*/createIcon(dataLineChartSolid)
export default IconLineChartSolid
